import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import "./StatusBadge.css"

// Mapea cada estatus al mismo estilo de color usado en el módulo de órdenes
// (src/pages/room-service/ordenes/helpers/statusOrdenCell).
const STATUS_TYPE: Record<string, string> = {
    // estatus de orden
    entregada: "entregada",
    en_entrega: "en_entrega",
    por_entregar: "por_entregar",
    en_preparacion: "en_preparacion",
    en_servicio: "en_servicio",
    cancelada: "cancelada",
    cancelada_edicion: "cancelada",
    devolucion: "cancelada",
    // estatus de pago
    pagada: "entregada",
    no_pagada: "por_entregar",
    pendiente: "por_entregar",
}

const StatusBadge = ({ estatus }: { estatus?: string | null }): JSX.Element => {
    if (!estatus) {
        return <>-</>
    }

    const value = estatus.toLowerCase()
    const type = STATUS_TYPE[value] || "base"

    return (
        <span className={`ordenes-report__badge ordenes-report__badge--${type}`}>
            {formatTextWithCapitalize(estatus)}
        </span>
    )
}

export default StatusBadge
